/**
 * @file Component to present an empty plugin
 * @author Heino Lenting
 */
/**
 * Class to show the forecast
 */
var PluginViewEmptyComponent = /** @class */ (function () {
    function PluginViewEmptyComponent() {
    }
    return PluginViewEmptyComponent;
}());
export { PluginViewEmptyComponent };
